import { Pipe, PipeTransform } from "@angular/core";
import { DecimalPipe } from "@angular/common";

@Pipe({
    name: "preisNumber",
    standalone: false
})
export class PreisNumberPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}
  transform(value: any, postfix?: string): any {
    return typeof value === "number" ? `${this.decimalPipe.transform(value, "1.2-2")}\u00A0€` + (postfix || "") : "-";
  }
}
